import AsyncLoader from 'commons/components/AsyncLoader';

export default AsyncLoader(() => import(/* webpackChunkName: "CroppingTool" */ './CroppingTool'), {
  loading: () => null,
});
